// routes/FrontendRoutes.js

import React from 'react';
import { Route } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import Questions from '../components/Frontend/AccountDetails/Questions/Questions';

export const questionsRoutes = (
  <>
    <Route path="/questions" element={<MainLayout />}>
      <Route index element={<Questions />} />
    </Route>
  </>
);
